import {NotificationPublisherContext} from "../notification-publisher-context";
import { useContext } from 'react';

export const usePublishNotification = () => {
  return useContext(NotificationPublisherContext);
}
